module.exports = "<app-login *ngIf=\"!logged\">Login</app-login>\r\n\r\n<app-navbar *ngIf=\"logged\">Primary</app-navbar>"